import type { SessionId, VisitId } from '@/features/field-log/types/fieldLog';

const VISIT_ID_PATTERN = /^VIS-\d+$/;
const SESSION_ID_PATTERN = /^SES-\d+$/;

/** Validates a dynamic route value before it enters the Visit API boundary. */
export function fieldLogVisitId(value: string): VisitId {
  if (!VISIT_ID_PATTERN.test(value)) throw new Error('Invalid Field Log Visit ID');
  return value as VisitId;
}

/** Validates a dynamic route value before it enters the Session API boundary. */
export function fieldLogSessionId(value: string): SessionId {
  if (!SESSION_ID_PATTERN.test(value)) throw new Error('Invalid Field Log Session ID');
  return value as SessionId;
}
